var cov_1b0i7w6j9i = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Checkbox/CheckItem.tsx",
      hash = "4dcfe2a42f902f98c7dfc0d562e77d11b2d0451e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Checkbox/CheckItem.tsx",
    statementMap: {
      "0": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 18
        }
      },
      "1": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 49,
          column: 7
        }
      },
      "2": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 35
        }
      },
      "3": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 23
        }
      },
      "4": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 20
        }
      },
      "5": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 54
        }
      },
      "6": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 64
        }
      },
      "7": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 52
        }
      },
      "8": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 44
        }
      },
      "9": {
        start: {
          line: 61,
          column: 55
        },
        end: {
          line: 61,
          column: 65
        }
      },
      "10": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 65,
          column: 7
        }
      },
      "11": {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 64,
          column: 77
        }
      },
      "12": {
        start: {
          line: 69,
          column: 44
        },
        end: {
          line: 69,
          column: 54
        }
      },
      "13": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 66
        }
      },
      "14": {
        start: {
          line: 71,
          column: 41
        },
        end: {
          line: 71,
          column: 66
        }
      },
      "15": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 47
        }
      },
      "16": {
        start: {
          line: 72,
          column: 33
        },
        end: {
          line: 72,
          column: 47
        }
      },
      "17": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 70
        }
      },
      "18": {
        start: {
          line: 73,
          column: 44
        },
        end: {
          line: 73,
          column: 70
        }
      },
      "19": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 31
        }
      },
      "20": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 63
        }
      },
      "21": {
        start: {
          line: 78,
          column: 41
        },
        end: {
          line: 78,
          column: 63
        }
      },
      "22": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 51
        }
      },
      "23": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 26
        }
      },
      "24": {
        start: {
          line: 83,
          column: 14
        },
        end: {
          line: 83,
          column: 26
        }
      },
      "25": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 25
        }
      },
      "26": {
        start: {
          line: 88,
          column: 26
        },
        end: {
          line: 88,
          column: 36
        }
      },
      "27": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 37
        }
      },
      "28": {
        start: {
          line: 89,
          column: 27
        },
        end: {
          line: 89,
          column: 37
        }
      },
      "29": {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 102,
          column: 7
        }
      },
      "30": {
        start: {
          line: 94,
          column: 8
        },
        end: {
          line: 94,
          column: 57
        }
      },
      "31": {
        start: {
          line: 94,
          column: 51
        },
        end: {
          line: 94,
          column: 57
        }
      },
      "32": {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 99,
          column: 10
        }
      },
      "33": {
        start: {
          line: 106,
          column: 58
        },
        end: {
          line: 106,
          column: 68
        }
      },
      "34": {
        start: {
          line: 107,
          column: 26
        },
        end: {
          line: 107,
          column: 34
        }
      },
      "35": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 56
        }
      },
      "36": {
        start: {
          line: 108,
          column: 39
        },
        end: {
          line: 108,
          column: 55
        }
      },
      "37": {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 113,
          column: 7
        }
      },
      "38": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 111,
          column: 25
        }
      },
      "39": {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 14
        }
      },
      "40": {
        start: {
          line: 115,
          column: 18
        },
        end: {
          line: 115,
          column: 69
        }
      },
      "41": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 50
        }
      },
      "42": {
        start: {
          line: 117,
          column: 23
        },
        end: {
          line: 117,
          column: 50
        }
      },
      "43": {
        start: {
          line: 119,
          column: 6
        },
        end: {
          line: 119,
          column: 41
        }
      },
      "44": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 120,
          column: 51
        }
      },
      "45": {
        start: {
          line: 120,
          column: 20
        },
        end: {
          line: 120,
          column: 51
        }
      },
      "46": {
        start: {
          line: 124,
          column: 34
        },
        end: {
          line: 124,
          column: 44
        }
      },
      "47": {
        start: {
          line: 125,
          column: 22
        },
        end: {
          line: 125,
          column: 36
        }
      },
      "48": {
        start: {
          line: 126,
          column: 6
        },
        end: {
          line: 126,
          column: 49
        }
      },
      "49": {
        start: {
          line: 126,
          column: 20
        },
        end: {
          line: 126,
          column: 49
        }
      },
      "50": {
        start: {
          line: 130,
          column: 79
        },
        end: {
          line: 130,
          column: 89
        }
      },
      "51": {
        start: {
          line: 132,
          column: 18
        },
        end: {
          line: 132,
          column: 25
        }
      },
      "52": {
        start: {
          line: 134,
          column: 22
        },
        end: {
          line: 134,
          column: 39
        }
      },
      "53": {
        start: {
          line: 135,
          column: 23
        },
        end: {
          line: 135,
          column: 40
        }
      },
      "54": {
        start: {
          line: 137,
          column: 18
        },
        end: {
          line: 137,
          column: 51
        }
      },
      "55": {
        start: {
          line: 139,
          column: 24
        },
        end: {
          line: 155,
          column: 7
        }
      },
      "56": {
        start: {
          line: 157,
          column: 51
        },
        end: {
          line: 157,
          column: 64
        }
      },
      "57": {
        start: {
          line: 159,
          column: 8
        },
        end: {
          line: 161,
          column: 16
        }
      },
      "58": {
        start: {
          line: 163,
          column: 20
        },
        end: {
          line: 163,
          column: 80
        }
      },
      "59": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 198,
          column: 7
        }
      },
      "60": {
        start: {
          line: 202,
          column: 2
        },
        end: {
          line: 202,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "checkItem",
        decl: {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 29,
            column: 18
          }
        },
        loc: {
          start: {
            line: 29,
            column: 89
          },
          end: {
            line: 203,
            column: 1
          }
        },
        line: 29
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        },
        loc: {
          start: {
            line: 44,
            column: 39
          },
          end: {
            line: 58,
            column: 5
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        },
        loc: {
          start: {
            line: 60,
            column: 50
          },
          end: {
            line: 66,
            column: 5
          }
        },
        line: 60
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        loc: {
          start: {
            line: 68,
            column: 17
          },
          end: {
            line: 75,
            column: 5
          }
        },
        line: 68
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        },
        loc: {
          start: {
            line: 77,
            column: 39
          },
          end: {
            line: 80,
            column: 5
          }
        },
        line: 77
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        },
        loc: {
          start: {
            line: 82,
            column: 34
          },
          end: {
            line: 84,
            column: 5
          }
        },
        line: 82
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 86,
            column: 14
          },
          end: {
            line: 86,
            column: 15
          }
        },
        loc: {
          start: {
            line: 86,
            column: 57
          },
          end: {
            line: 90,
            column: 5
          }
        },
        line: 86
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        },
        loc: {
          start: {
            line: 92,
            column: 34
          },
          end: {
            line: 103,
            column: 5
          }
        },
        line: 92
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        loc: {
          start: {
            line: 105,
            column: 54
          },
          end: {
            line: 121,
            column: 5
          }
        },
        line: 105
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 108,
            column: 33
          },
          end: {
            line: 108,
            column: 34
          }
        },
        loc: {
          start: {
            line: 108,
            column: 39
          },
          end: {
            line: 108,
            column: 55
          }
        },
        line: 108
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 123,
            column: 5
          }
        },
        loc: {
          start: {
            line: 123,
            column: 35
          },
          end: {
            line: 127,
            column: 5
          }
        },
        line: 123
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        },
        loc: {
          start: {
            line: 129,
            column: 13
          },
          end: {
            line: 199,
            column: 5
          }
        },
        line: 129
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 48,
            column: 17
          },
          end: {
            line: 48,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 48,
            column: 55
          },
          end: {
            line: 48,
            column: 64
          }
        }, {
          start: {
            line: 48,
            column: 67
          },
          end: {
            line: 48,
            column: 80
          }
        }],
        line: 48
      },
      "1": {
        loc: {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        }, {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        }],
        line: 62
      },
      "2": {
        loc: {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 35
          }
        }, {
          start: {
            line: 62,
            column: 39
          },
          end: {
            line: 62,
            column: 60
          }
        }],
        line: 62
      },
      "3": {
        loc: {
          start: {
            line: 64,
            column: 33
          },
          end: {
            line: 64,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 64,
            column: 45
          },
          end: {
            line: 64,
            column: 52
          }
        }, {
          start: {
            line: 64,
            column: 55
          },
          end: {
            line: 64,
            column: 74
          }
        }],
        line: 64
      },
      "4": {
        loc: {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 66
          }
        }, {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 66
          }
        }],
        line: 71
      },
      "5": {
        loc: {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 72,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 72,
            column: 47
          }
        }, {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 72,
            column: 47
          }
        }],
        line: 72
      },
      "6": {
        loc: {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 73,
            column: 70
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 73,
            column: 70
          }
        }, {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 73,
            column: 70
          }
        }],
        line: 73
      },
      "7": {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 63
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 63
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 63
          }
        }],
        line: 78
      },
      "8": {
        loc: {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 26
          }
        }, {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 26
          }
        }],
        line: 83
      },
      "9": {
        loc: {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 37
          }
        }, {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 37
          }
        }],
        line: 89
      },
      "10": {
        loc: {
          start: {
            line: 93,
            column: 6
          },
          end: {
            line: 102,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 6
          },
          end: {
            line: 102,
            column: 7
          }
        }, {
          start: {
            line: 93,
            column: 6
          },
          end: {
            line: 102,
            column: 7
          }
        }],
        line: 93
      },
      "11": {
        loc: {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 94,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 94,
            column: 57
          }
        }, {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 94,
            column: 57
          }
        }],
        line: 94
      },
      "12": {
        loc: {
          start: {
            line: 94,
            column: 12
          },
          end: {
            line: 94,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 12
          },
          end: {
            line: 94,
            column: 28
          }
        }, {
          start: {
            line: 94,
            column: 32
          },
          end: {
            line: 94,
            column: 49
          }
        }],
        line: 94
      },
      "13": {
        loc: {
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }, {
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }],
        line: 110
      },
      "14": {
        loc: {
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 110,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 110,
            column: 27
          }
        }, {
          start: {
            line: 110,
            column: 31
          },
          end: {
            line: 110,
            column: 39
          }
        }],
        line: 110
      },
      "15": {
        loc: {
          start: {
            line: 115,
            column: 18
          },
          end: {
            line: 115,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 115,
            column: 30
          },
          end: {
            line: 115,
            column: 46
          }
        }, {
          start: {
            line: 115,
            column: 49
          },
          end: {
            line: 115,
            column: 69
          }
        }],
        line: 115
      },
      "16": {
        loc: {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 50
          }
        }, {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 50
          }
        }],
        line: 117
      },
      "17": {
        loc: {
          start: {
            line: 119,
            column: 14
          },
          end: {
            line: 119,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 119,
            column: 24
          },
          end: {
            line: 119,
            column: 29
          }
        }, {
          start: {
            line: 119,
            column: 32
          },
          end: {
            line: 119,
            column: 41
          }
        }],
        line: 119
      },
      "18": {
        loc: {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 120,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 120,
            column: 51
          }
        }, {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 120,
            column: 51
          }
        }],
        line: 120
      },
      "19": {
        loc: {
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 126,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 126,
            column: 49
          }
        }, {
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 126,
            column: 49
          }
        }],
        line: 126
      },
      "20": {
        loc: {
          start: {
            line: 137,
            column: 18
          },
          end: {
            line: 137,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 18
          },
          end: {
            line: 137,
            column: 26
          }
        }, {
          start: {
            line: 137,
            column: 31
          },
          end: {
            line: 137,
            column: 39
          }
        }, {
          start: {
            line: 137,
            column: 43
          },
          end: {
            line: 137,
            column: 50
          }
        }],
        line: 137
      },
      "21": {
        loc: {
          start: {
            line: 142,
            column: 10
          },
          end: {
            line: 142,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 10
          },
          end: {
            line: 142,
            column: 13
          }
        }, {
          start: {
            line: 142,
            column: 17
          },
          end: {
            line: 142,
            column: 27
          }
        }],
        line: 142
      },
      "22": {
        loc: {
          start: {
            line: 143,
            column: 10
          },
          end: {
            line: 143,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 143,
            column: 10
          },
          end: {
            line: 143,
            column: 26
          }
        }, {
          start: {
            line: 143,
            column: 30
          },
          end: {
            line: 143,
            column: 39
          }
        }],
        line: 143
      },
      "23": {
        loc: {
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 144,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 144,
            column: 37
          }
        }, {
          start: {
            line: 144,
            column: 41
          },
          end: {
            line: 144,
            column: 56
          }
        }],
        line: 144
      },
      "24": {
        loc: {
          start: {
            line: 145,
            column: 10
          },
          end: {
            line: 145,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 145,
            column: 10
          },
          end: {
            line: 145,
            column: 18
          }
        }, {
          start: {
            line: 145,
            column: 22
          },
          end: {
            line: 145,
            column: 30
          }
        }],
        line: 145
      },
      "25": {
        loc: {
          start: {
            line: 146,
            column: 10
          },
          end: {
            line: 146,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 146,
            column: 10
          },
          end: {
            line: 146,
            column: 17
          }
        }, {
          start: {
            line: 146,
            column: 21
          },
          end: {
            line: 146,
            column: 30
          }
        }],
        line: 146
      },
      "26": {
        loc: {
          start: {
            line: 148,
            column: 10
          },
          end: {
            line: 148,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 148,
            column: 10
          },
          end: {
            line: 148,
            column: 13
          }
        }, {
          start: {
            line: 148,
            column: 17
          },
          end: {
            line: 148,
            column: 22
          }
        }],
        line: 148
      },
      "27": {
        loc: {
          start: {
            line: 157,
            column: 51
          },
          end: {
            line: 157,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 51
          },
          end: {
            line: 157,
            column: 58
          }
        }, {
          start: {
            line: 157,
            column: 62
          },
          end: {
            line: 157,
            column: 64
          }
        }],
        line: 157
      },
      "28": {
        loc: {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 161,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 160,
            column: 10
          },
          end: {
            line: 160,
            column: 117
          }
        }, {
          start: {
            line: 161,
            column: 12
          },
          end: {
            line: 161,
            column: 16
          }
        }],
        line: 159
      },
      "29": {
        loc: {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 159,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 159,
            column: 16
          }
        }, {
          start: {
            line: 159,
            column: 20
          },
          end: {
            line: 159,
            column: 36
          }
        }],
        line: 159
      },
      "30": {
        loc: {
          start: {
            line: 160,
            column: 64
          },
          end: {
            line: 160,
            column: 109
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 160,
            column: 74
          },
          end: {
            line: 160,
            column: 89
          }
        }, {
          start: {
            line: 160,
            column: 92
          },
          end: {
            line: 160,
            column: 109
          }
        }],
        line: 160
      },
      "31": {
        loc: {
          start: {
            line: 163,
            column: 20
          },
          end: {
            line: 163,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 163,
            column: 59
          },
          end: {
            line: 163,
            column: 75
          }
        }, {
          start: {
            line: 163,
            column: 78
          },
          end: {
            line: 163,
            column: 80
          }
        }],
        line: 163
      },
      "32": {
        loc: {
          start: {
            line: 171,
            column: 20
          },
          end: {
            line: 171,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 171,
            column: 31
          },
          end: {
            line: 171,
            column: 40
          }
        }, {
          start: {
            line: 171,
            column: 43
          },
          end: {
            line: 171,
            column: 44
          }
        }],
        line: 171
      },
      "33": {
        loc: {
          start: {
            line: 182,
            column: 18
          },
          end: {
            line: 182,
            column: 46
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 182,
            column: 29
          },
          end: {
            line: 182,
            column: 39
          }
        }, {
          start: {
            line: 182,
            column: 42
          },
          end: {
            line: 182,
            column: 46
          }
        }],
        line: 182
      },
      "34": {
        loc: {
          start: {
            line: 188,
            column: 11
          },
          end: {
            line: 188,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 188,
            column: 11
          },
          end: {
            line: 188,
            column: 19
          }
        }, {
          start: {
            line: 188,
            column: 23
          },
          end: {
            line: 188,
            column: 32
          }
        }, {
          start: {
            line: 188,
            column: 36
          },
          end: {
            line: 188,
            column: 95
          }
        }],
        line: 188
      },
      "35": {
        loc: {
          start: {
            line: 189,
            column: 11
          },
          end: {
            line: 191,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 189,
            column: 11
          },
          end: {
            line: 189,
            column: 20
          }
        }, {
          start: {
            line: 189,
            column: 24
          },
          end: {
            line: 189,
            column: 33
          }
        }, {
          start: {
            line: 189,
            column: 37
          },
          end: {
            line: 189,
            column: 44
          }
        }, {
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 190,
            column: 105
          }
        }],
        line: 189
      },
      "36": {
        loc: {
          start: {
            line: 192,
            column: 11
          },
          end: {
            line: 196,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 192,
            column: 11
          },
          end: {
            line: 192,
            column: 19
          }
        }, {
          start: {
            line: 193,
            column: 12
          },
          end: {
            line: 195,
            column: 19
          }
        }],
        line: 192
      },
      "37": {
        loc: {
          start: {
            line: 194,
            column: 15
          },
          end: {
            line: 194,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 194,
            column: 25
          },
          end: {
            line: 194,
            column: 70
          }
        }, {
          start: {
            line: 194,
            column: 73
          },
          end: {
            line: 194,
            column: 77
          }
        }],
        line: 194
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0, 0],
      "35": [0, 0, 0, 0],
      "36": [0, 0],
      "37": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Checkbox/CheckItem.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { defaultProps } from '../utils/defaultProps';
import { getUidStr } from '../utils/uid';
import { getDirectionClass } from '../utils/classname';
import { isEnterPress, isFunc } from '../utils/is';
import Input from '../Input';
import Spin from '../Spin';
import { checkinputClass } from './styles';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';

function checkItem(type) {
  cov_1b0i7w6j9i.f[0]++;

  var CheckItem =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CheckItem, _PureComponent);

    var _super = _createSuper2(CheckItem);

    function CheckItem(props) {
      var _this;

      _classCallCheck(this, CheckItem);

      cov_1b0i7w6j9i.f[1]++;
      cov_1b0i7w6j9i.s[0]++;
      _this = _super.call(this, props);
      _this.id = void 0;
      _this.input = void 0;
      _this.el = void 0;

      _this.onClick = function (e) {
        cov_1b0i7w6j9i.f[6]++;
        cov_1b0i7w6j9i.s[25]++;
        e.stopPropagation();

        var _ref = (cov_1b0i7w6j9i.s[26]++, _this.props),
            onClick = _ref.onClick;

        cov_1b0i7w6j9i.s[27]++;

        if (isFunc(onClick)) {
          cov_1b0i7w6j9i.b[9][0]++;
          cov_1b0i7w6j9i.s[28]++;
          onClick(e);
        } else {
          cov_1b0i7w6j9i.b[9][1]++;
        }
      };

      cov_1b0i7w6j9i.s[1]++;
      _this.state = {
        checked: typeof props.checked === 'function' ? (cov_1b0i7w6j9i.b[0][0]++, undefined) : (cov_1b0i7w6j9i.b[0][1]++, props.checked)
      };
      cov_1b0i7w6j9i.s[2]++;
      _this.id = "cb_".concat(getUidStr());
      cov_1b0i7w6j9i.s[3]++;
      _this.input = null;
      cov_1b0i7w6j9i.s[4]++;
      _this.el = null;
      cov_1b0i7w6j9i.s[5]++;
      _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
      cov_1b0i7w6j9i.s[6]++;
      _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
      cov_1b0i7w6j9i.s[7]++;
      _this.handleEnter = _this.handleEnter.bind(_assertThisInitialized(_this));
      cov_1b0i7w6j9i.s[8]++;
      _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(CheckItem, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        cov_1b0i7w6j9i.f[2]++;

        var _ref2 = (cov_1b0i7w6j9i.s[9]++, this.props),
            checked = _ref2.checked,
            inputable = _ref2.inputable,
            value = _ref2.value,
            htmlValue = _ref2.htmlValue;

        cov_1b0i7w6j9i.s[10]++;

        if ((cov_1b0i7w6j9i.b[2][0]++, prevProps.value !== value) && (cov_1b0i7w6j9i.b[2][1]++, checked === undefined)) {
          cov_1b0i7w6j9i.b[1][0]++;
          cov_1b0i7w6j9i.s[11]++;
          // eslint-disable-next-line
          this.setState({
            checked: inputable ? (cov_1b0i7w6j9i.b[3][0]++, !!value) : (cov_1b0i7w6j9i.b[3][1]++, value === htmlValue)
          });
        } else {
          cov_1b0i7w6j9i.b[1][1]++;
        }
      }
    }, {
      key: "getChecked",
      value: function getChecked() {
        cov_1b0i7w6j9i.f[3]++;

        var _ref3 = (cov_1b0i7w6j9i.s[12]++, this.props),
            checked = _ref3.checked,
            value = _ref3.value,
            htmlValue = _ref3.htmlValue; // 传函数的用法


        cov_1b0i7w6j9i.s[13]++;

        if (typeof checked === 'function') {
          cov_1b0i7w6j9i.b[4][0]++;
          cov_1b0i7w6j9i.s[14]++;
          return checked(htmlValue);
        } else {
          cov_1b0i7w6j9i.b[4][1]++;
        }

        cov_1b0i7w6j9i.s[15]++;

        if (checked !== undefined) {
          cov_1b0i7w6j9i.b[5][0]++;
          cov_1b0i7w6j9i.s[16]++;
          return checked;
        } else {
          cov_1b0i7w6j9i.b[5][1]++;
        }

        cov_1b0i7w6j9i.s[17]++;

        if (this.state.checked === undefined) {
          cov_1b0i7w6j9i.b[6][0]++;
          cov_1b0i7w6j9i.s[18]++;
          return value === htmlValue;
        } else {
          cov_1b0i7w6j9i.b[6][1]++;
        }

        cov_1b0i7w6j9i.s[19]++;
        return this.state.checked;
      }
    }, {
      key: "getProp",
      value: function getProp(key) {
        cov_1b0i7w6j9i.f[4]++;
        cov_1b0i7w6j9i.s[20]++;

        if (this.props[key] !== undefined) {
          cov_1b0i7w6j9i.b[7][0]++;
          cov_1b0i7w6j9i.s[21]++;
          return this.props[key];
        } else {
          cov_1b0i7w6j9i.b[7][1]++;
        }

        cov_1b0i7w6j9i.s[22]++;
        return this.state[key];
      }
    }, {
      key: "bindRef",
      value: function bindRef(el) {
        cov_1b0i7w6j9i.f[5]++;
        cov_1b0i7w6j9i.s[23]++;

        if (el) {
          cov_1b0i7w6j9i.b[8][0]++;
          cov_1b0i7w6j9i.s[24]++;
          this.el = el;
        } else {
          cov_1b0i7w6j9i.b[8][1]++;
        }
      }
    }, {
      key: "handleEnter",
      value: function handleEnter(e) {
        cov_1b0i7w6j9i.f[7]++;
        cov_1b0i7w6j9i.s[29]++;

        if (isEnterPress(e)) {
          cov_1b0i7w6j9i.b[10][0]++;
          cov_1b0i7w6j9i.s[30]++;

          if ((cov_1b0i7w6j9i.b[12][0]++, type === 'radio') && (cov_1b0i7w6j9i.b[12][1]++, this.getChecked())) {
            cov_1b0i7w6j9i.b[11][0]++;
            cov_1b0i7w6j9i.s[31]++;
            return;
          } else {
            cov_1b0i7w6j9i.b[11][1]++;
          }

          cov_1b0i7w6j9i.s[32]++;
          this.handleChange({
            target: {
              checked: !this.getChecked()
            }
          }); // e.target.click()
          // if (this.el) this.el.focus()
        } else {
          cov_1b0i7w6j9i.b[10][1]++;
        }
      }
    }, {
      key: "handleChange",
      value: function handleChange(e) {
        var _this2 = this;

        cov_1b0i7w6j9i.f[8]++;

        var _ref4 = (cov_1b0i7w6j9i.s[33]++, this.props),
            onChange = _ref4.onChange,
            onRawChange = _ref4.onRawChange,
            index = _ref4.index,
            inputable = _ref4.inputable;

        var _ref5 = (cov_1b0i7w6j9i.s[34]++, e.target),
            checked = _ref5.checked;

        cov_1b0i7w6j9i.s[35]++;
        this.setState({
          checked: checked
        }, function () {
          cov_1b0i7w6j9i.f[9]++;
          cov_1b0i7w6j9i.s[36]++;
          return _this2.el.focus();
        });
        cov_1b0i7w6j9i.s[37]++;

        if ((cov_1b0i7w6j9i.b[14][0]++, type === 'switch') && (cov_1b0i7w6j9i.b[14][1]++, onChange)) {
          cov_1b0i7w6j9i.b[13][0]++;
          cov_1b0i7w6j9i.s[38]++;
          onChange(checked);
          cov_1b0i7w6j9i.s[39]++;
          return;
        } else {
          cov_1b0i7w6j9i.b[13][1]++;
        }

        var value = (cov_1b0i7w6j9i.s[40]++, inputable ? (cov_1b0i7w6j9i.b[15][0]++, this.props.value) : (cov_1b0i7w6j9i.b[15][1]++, this.props.htmlValue));
        cov_1b0i7w6j9i.s[41]++;

        if (onRawChange) {
          cov_1b0i7w6j9i.b[16][0]++;
          cov_1b0i7w6j9i.s[42]++;
          onRawChange(value, checked);
        } else {
          cov_1b0i7w6j9i.b[16][1]++;
        }

        cov_1b0i7w6j9i.s[43]++;
        value = checked ? (cov_1b0i7w6j9i.b[17][0]++, value) : (cov_1b0i7w6j9i.b[17][1]++, undefined);
        cov_1b0i7w6j9i.s[44]++;

        if (onChange) {
          cov_1b0i7w6j9i.b[18][0]++;
          cov_1b0i7w6j9i.s[45]++;
          onChange(value, checked, index);
        } else {
          cov_1b0i7w6j9i.b[18][1]++;
        }
      }
    }, {
      key: "handleInputChange",
      value: function handleInputChange(val) {
        cov_1b0i7w6j9i.f[10]++;

        var _ref6 = (cov_1b0i7w6j9i.s[46]++, this.props),
            onChange = _ref6.onChange,
            index = _ref6.index;

        var checked = (cov_1b0i7w6j9i.s[47]++, val.length > 0);
        cov_1b0i7w6j9i.s[48]++;

        if (onChange) {
          cov_1b0i7w6j9i.b[19][0]++;
          cov_1b0i7w6j9i.s[49]++;
          onChange(val, checked, index);
        } else {
          cov_1b0i7w6j9i.b[19][1]++;
        }
      }
    }, {
      key: "render",
      value: function render() {
        cov_1b0i7w6j9i.f[11]++;

        var _ref7 = (cov_1b0i7w6j9i.s[50]++, this.props),
            disabled = _ref7.disabled,
            style = _ref7.style,
            content = _ref7.content,
            size = _ref7.size,
            children = _ref7.children,
            inputable = _ref7.inputable,
            loading = _ref7.loading;

        var rtl = (cov_1b0i7w6j9i.s[51]++, isRTL());
        var checked = (cov_1b0i7w6j9i.s[52]++, this.getChecked());
        var isSwitch = (cov_1b0i7w6j9i.s[53]++, type === 'switch');
        var ban = (cov_1b0i7w6j9i.s[54]++, (cov_1b0i7w6j9i.b[20][0]++, disabled) || (cov_1b0i7w6j9i.b[20][1]++, isSwitch) && (cov_1b0i7w6j9i.b[20][2]++, loading));
        var className = (cov_1b0i7w6j9i.s[55]++, classnames(checkinputClass('_', (cov_1b0i7w6j9i.b[21][0]++, ban) && (cov_1b0i7w6j9i.b[21][1]++, 'disabled'), (cov_1b0i7w6j9i.b[22][0]++, checked === true) && (cov_1b0i7w6j9i.b[22][1]++, 'checked'), (cov_1b0i7w6j9i.b[23][0]++, checked === 'indeterminate') && (cov_1b0i7w6j9i.b[23][1]++, 'indeterminate'), (cov_1b0i7w6j9i.b[24][0]++, isSwitch) && (cov_1b0i7w6j9i.b[24][1]++, 'switch'), (cov_1b0i7w6j9i.b[25][0]++, loading) && (cov_1b0i7w6j9i.b[25][1]++, 'loading'), "".concat(type, "-container"), (cov_1b0i7w6j9i.b[26][0]++, rtl) && (cov_1b0i7w6j9i.b[26][1]++, 'rtl'), {
          large: size === 'large',
          small: size === 'small'
        }), this.props.className));

        var _ref8 = (cov_1b0i7w6j9i.s[56]++, (cov_1b0i7w6j9i.b[27][0]++, content) || (cov_1b0i7w6j9i.b[27][1]++, [])),
            _ref9 = _slicedToArray(_ref8, 2),
            checkedChildren = _ref9[0],
            uncheckedChildren = _ref9[1];

        var switchChildren = (cov_1b0i7w6j9i.s[57]++, (cov_1b0i7w6j9i.b[29][0]++, isSwitch) && (cov_1b0i7w6j9i.b[29][1]++, size !== 'small') ? (cov_1b0i7w6j9i.b[28][0]++,
        /*#__PURE__*/
        React.createElement("span", {
          className: checkinputClass('switch-children'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 160,
            columnNumber: 11
          }
        }, checked ? (cov_1b0i7w6j9i.b[30][0]++, checkedChildren) : (cov_1b0i7w6j9i.b[30][1]++, uncheckedChildren))) : (cov_1b0i7w6j9i.b[28][1]++, null));
        var value = (cov_1b0i7w6j9i.s[58]++, typeof this.props.value === 'string' ? (cov_1b0i7w6j9i.b[31][0]++, this.props.value) : (cov_1b0i7w6j9i.b[31][1]++, ''));
        cov_1b0i7w6j9i.s[59]++;
        return (
          /*#__PURE__*/
          React.createElement("label", Object.assign({
            onKeyDown: this.handleEnter,
            className: className,
            style: style,
            htmlFor: this.id,
            tabIndex: disabled ? (cov_1b0i7w6j9i.b[32][0]++, undefined) : (cov_1b0i7w6j9i.b[32][1]++, 0),
            ref: this.bindRef
            /* @ts-ignore */
            ,
            disabled: ban
          }, getDataset(this.props), {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 166,
              columnNumber: 9
            }
          }), switchChildren,
          /*#__PURE__*/
          React.createElement("input", {
            id: this.id,
            disabled: ban,
            tabIndex: -1,
            type: isSwitch ? (cov_1b0i7w6j9i.b[33][0]++, 'checkbox') : (cov_1b0i7w6j9i.b[33][1]++, type),
            onClick: this.onClick,
            onChange: this.handleChange,
            checked: checked,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 178,
              columnNumber: 11
            }
          }),
          /*#__PURE__*/
          React.createElement("i", {
            className: checkinputClass('indicator', type),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 187,
              columnNumber: 11
            }
          }), (cov_1b0i7w6j9i.b[34][0]++, children) && (cov_1b0i7w6j9i.b[34][1]++, !isSwitch) && (cov_1b0i7w6j9i.b[34][2]++,
          /*#__PURE__*/
          React.createElement("span", {
            className: checkinputClass('desc'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 188,
              columnNumber: 37
            }
          }, children)), (cov_1b0i7w6j9i.b[35][0]++, inputable) && (cov_1b0i7w6j9i.b[35][1]++, !isSwitch) && (cov_1b0i7w6j9i.b[35][2]++, checked) && (cov_1b0i7w6j9i.b[35][3]++,
          /*#__PURE__*/
          React.createElement(Input, {
            className: checkinputClass('text'),
            onChange: this.handleInputChange,
            value: value,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 190,
              columnNumber: 13
            }
          })), (cov_1b0i7w6j9i.b[36][0]++, isSwitch) && (cov_1b0i7w6j9i.b[36][1]++,
          /*#__PURE__*/
          React.createElement("span", {
            className: checkinputClass(getDirectionClass('switch-indicator')),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 193,
              columnNumber: 13
            }
          }, loading ? (cov_1b0i7w6j9i.b[37][0]++,
          /*#__PURE__*/
          React.createElement(Spin, {
            size: "auto",
            color: "none",
            name: "ring",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 194,
              columnNumber: 26
            }
          })) : (cov_1b0i7w6j9i.b[37][1]++, null))))
        );
      }
    }]);

    return CheckItem;
  }(PureComponent);

  CheckItem.defaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
    htmlValue: true,
    onClick: undefined,
    content: []
  });
  cov_1b0i7w6j9i.s[60]++;
  return CheckItem;
}

export default checkItem;